import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { api } from 'services';
import { notificationContainer } from 'utils/notificationContainer';

import { PayloadAction } from '@reduxjs/toolkit';
import fileDownload from 'js-file-download';
import { durationDates } from 'utils/durationDates';
import axios from 'axios';
import {
	TGetSalesReportsResponsePayload,
	TGetSalesReportsRequestPayload,
	TDownloadSalesReportRequestPayload,
	TDownloadSalesReportResponsePayload,
	TGetVatReportsRequestPayload,
	TGetVatReportsResponsePayload,
	TDownloadVatReportRequestPayload,
	TDownloadVatReportsResponsePayload,
} from './types';
import {
	getSalesReportsRequest,
	getSalesReportsSuccess,
	downloadSalesReportRequest,
	downloadSalesReportSuccess,
	setDownloadedSalesReport,
	getVatReportsRequest,
	getVatReportsSuccess,
	downloadVatReportRequest,
	downloadVatReportsSuccess,
	setDownloadedVatReport,
} from './reducer';
import { refreshTokenByTimeOutRequest, refreshTokenByTimeOutSuccess } from '../auth/reducer';

function* getSalesReportsWorker(action: PayloadAction<TGetSalesReportsRequestPayload>) {
	const { payload } = action;

	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TGetSalesReportsResponsePayload = yield call(
			api.reports.getSalesReports,
			payload,
		);
		yield put(getSalesReportsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(error?.message ?? 'Error', 'error');
			yield put(getSalesReportsSuccess(null));
		}
	}
}

function* downloadSalesReportWorker(action: PayloadAction<TDownloadSalesReportRequestPayload>) {
	const { payload } = action;

	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TDownloadSalesReportResponsePayload = yield call(
			api.reports.downloadSalesReport,
			payload,
		);
		yield put(downloadSalesReportSuccess(response));
		// const downloadUrl = get(response, 'data.downloadUrl');
		// const fileName = get(response, 'data.fileName');
		// const reports: TGetSalesReportsResponsePayload = yield select(getSalesReports);

		// const intervalStringArray = durationDates(payload.reportId);

		if (response) {
			yield fileDownload(response, `sales_report_${payload.reportId}.zip`);
		}
		yield put(setDownloadedSalesReport());
	} catch (error) {
		// console.log('error', error);
		if (axios.isAxiosError(error)) {
			notificationContainer(error?.message ?? 'Error', 'error');
			yield put(downloadSalesReportSuccess(null));
		}
	}
}

function* getVatReportsWorker(action: PayloadAction<TGetVatReportsRequestPayload>) {
	const { payload } = action;

	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TGetVatReportsResponsePayload = yield call(api.reports.getVatReports, payload);
		yield put(getVatReportsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(error?.message ?? 'Error', 'error');
			yield put(getVatReportsSuccess(null));
		}
	}
}

function* downloadVatReportWorker(action: PayloadAction<TDownloadVatReportRequestPayload>) {
	const { payload } = action;

	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TDownloadVatReportsResponsePayload = yield call(
			api.reports.downloadVatReport,
			payload,
		);
		yield put(downloadVatReportsSuccess(response));

		if (response) {
			yield fileDownload(response, payload.fileName);
		}
		yield put(setDownloadedVatReport());
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(error?.message ?? 'Error', 'error');
			yield put(downloadVatReportsSuccess(null));
		}
	}
}

export function* reportsSaga() {
	yield takeEvery(getSalesReportsRequest, getSalesReportsWorker);
	yield takeEvery(downloadSalesReportRequest, downloadSalesReportWorker);
	yield takeEvery(getVatReportsRequest, getVatReportsWorker);
	yield takeEvery(downloadVatReportRequest, downloadVatReportWorker);
}
